import React from 'react';
import styled from 'styled-components';

import './global.module.less';

const Content = styled.div`
	width: 100%;
	max-height: 440px;
	min-height: 108px;
	display: flex;
	justify-content: center;
	align-items: center;
`;
const Image = styled.img`
	max-width: 1920px;
	max-height: 440px;
	min-height: 86px;
	border-radius: 4px;
	width: 100%;
	object-fit: contain;
`;

const CoverBanner = ({ imageUrl }: { imageUrl: string }): JSX.Element => (
	<Content>
		<Image src={imageUrl} alt="" />
	</Content>
);

export default CoverBanner;
